<template lang="pug">
  div
    el-row.labelStyle
      el-col(:span="12")
        app-display(
          label="Localizações:",
          :content="dadosJson.georreferenciamento.localizacoes.length ? 'Sim' : 'Não'"
        )
        app-display(
          label="Denominação:",
          :content="dadosJson.georreferenciamento.denominacao || '-'"
        )
        app-display(
          label="Possui Georreferenciamento:",
          :content="dadosJson.georreferenciamento.possuiGeorreferenciamento || '-'"
        )
        app-display(
          label="Nome do Responsável:",
          :content="dadosJson.georreferenciamento.responsavel.nome || '-'"
        )
        app-display(
          label="Código INCRA do Responsável:",
          :content="dadosJson.georreferenciamento.responsavel.codigoIncra || '-'"
        )
        app-display(
          label="CREA/RNP do Responsável:",
          :content="dadosJson.georreferenciamento.responsavel.creaRnp || '-'"
        )
        app-display(
          label="Formação do Responsável:",
          :content="dadosJson.georreferenciamento.responsavel.formacao || '-'"
        )
        app-display(
          label="Código de Credenciamento do Responsável:",
          :content="dadosJson.georreferenciamento.responsavel.codigoCredenciamento || '-'"
        )
        app-display(
          label="Matrícula do Responsável:",
          :content="dadosJson.georreferenciamento.responsavel.matricula || '-'"
        )
        app-display(label="Documentos:")
        ul
          li(v-for="documento in dadosJson.georreferenciamento.documentos" :key="documento.id") {{ documento.nome }}
</template>
<script>
import AppDivider from '../AppDivider'
import AppDisplay from '../AppDisplay'
import AppDisplayMultiple from '@/components/AppDisplayMultiple'

export default {
  props: {
    dadosJson: {
      type: Object,
      required: false
    }
  },
  components: {
    AppDisplay,
    AppDivider,
    AppDisplayMultiple
  },

  methods: {
    formatTelefone (telefones) {
      return telefones.map(telefone => {
        if (telefone?.numero) {
          return telefone.numero + (telefone.identificacao ? ` - ${telefone.identificacao}` : '')
        } else {
          return telefone
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.margin-top {
    margin-top: 10px;
}

>>>.text .text {
    color: #ff0000 !important;
}

@media (max-width: 780px) {
    .labelStyle {
        display: flex;
        flex-direction: column;
        width: 395px;
    }

    .margin-top {
        display: flex;
        flex-direction: column;
        width: 490px;
    }
}
</style>



// WEBPACK FOOTER //
// src/components/informacoesCadastro/GeorreferenciamentoRf.vue